import { render } from "./ForecastMonthly.vue?vue&type=template&id=02a8bb54"
import script from "./ForecastMonthly.vue?vue&type=script&lang=js"
export * from "./ForecastMonthly.vue?vue&type=script&lang=js"
script.render = render

export default script